export enum SystemType {
	Sensors = 'Sensors',
}

export interface TilingJobPayload {
	systemType: SystemType;
}

export enum JobProgress {
	QUEUED = 'queued',
	SENDING = 'sending',
	SUCCESS = 'success',
	FAILED = 'failed',
}

export interface TilingJob {
	progress: JobProgress;
	lastRun: Date;
}

export enum JobQueue {
	FREE = 'free',
	BLOCKED = 'blocked',
}

export interface TilingStoreState {
	jobs: {
		[System in SystemType]: Partial<TilingJob>;
	};
	queues: {
		[System in SystemType]: JobQueue;
	};
}
